var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLoadingCircular = function SvgLoadingCircular(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85.87,
    height: 96.49,
    viewBox: "0 0 85.87 96.49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.22.31,21.551,8.9l-4.476,1.412c-3.305,1.033-2.324,4.218,1,3.167,1.394-.43,2.772-.878,4.149-1.308l5.543,6.937,1.067-.224-3.185-7.333A26.9,26.9,0,1,1,.945,35.118L.67,34.636.308,34A30.668,30.668,0,1,0,24.873,8.142L24.271,0c-.362.1-.516.155-1.05.31Z",
    transform: "translate(0)",
    fill: "#02c5e3"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoadingCircular, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loadingCircular.ff372b29.svg";
export { ForwardRef as ReactComponent };